<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9.99214 18.6316C4.4582 17.894 0.181133 13.1784 0.131592 7.45178C5.66737 8.1894 9.94444 12.9068 9.99214 18.6316Z"
    fill="white" />
  <path
    d="M11.5115 18.6316C17.0455 17.894 21.3244 13.1784 21.3721 7.45178C15.8363 8.1894 11.5592 12.9068 11.5115 18.6316Z"
    fill="white" />
  <path
    d="M10.7535 8.20223C8.66545 8.20223 6.9682 6.50315 6.9682 4.41691C6.9682 2.33067 8.66545 0.631592 10.7535 0.631592C12.8416 0.631592 14.5388 2.33067 14.5388 4.41691C14.5388 6.50315 12.8398 8.20223 10.7535 8.20223ZM10.7535 2.13251C9.49481 2.13251 8.46912 3.15636 8.46912 4.41691C8.46912 5.67746 9.49297 6.70132 10.7535 6.70132C12.0141 6.70132 13.0379 5.67746 13.0379 4.41691C13.0379 3.15636 12.0141 2.13251 10.7535 2.13251Z"
    fill="white" />
</svg>
